import { useEffect, useState } from 'react';
import { forEach } from "lodash";
import { request } from '../utils/request';

import '../App.css';

const Event = () => {
  const [eventList, setEventList] = useState([]);

  useEffect(() => {
    getEventData();
  }, [])

  const getEventData = async () => {
    const res = await request('event');
    const eventList = [];
    if (res.data) {
      forEach(res.data, (item) => {
        eventList.push(Object.values(item))
      })
    }
    setEventList(eventList.splice(0 , 11));
  }

  return (
    <div className="card event">
      <h3 className="card-title">操作溯源</h3>
      <table class="event-table">
        <thead class="">
          <tr>
            <th scope="col" class="">
              大棚代号
            </th>
            <th scope="col" class="">
              分类
            </th>
            <th scope="col" class="">
              溯源
            </th>
            <th scope="col" class="">
              时间
            </th>
          </tr>
        </thead>
        <tbody>
          {eventList.map((tr, index) => (
            <tr class="">
              {tr.map(td => (
                <td class="">
                  {td}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
    </table>
    </div>
  );
}

export default Event;
